import { render, staticRenderFns } from "./cardCell.vue?vue&type=template&id=45c8799d&scoped=true"
import script from "./cardCell.vue?vue&type=script&lang=js"
export * from "./cardCell.vue?vue&type=script&lang=js"
import style0 from "./cardCell.vue?vue&type=style&index=0&id=45c8799d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c8799d",
  null
  
)

export default component.exports